import { connect } from "react-redux";
import { getListHopDongDelete } from "actions/DanhSachHopDongDelete";
import { DanhSachHopDongBiXoa } from "components/ThongKe/DanhSachHopDongBiXoa";

const mapStateToProps = (state) => ({
  DanhSachHopDongBiXoa: state.DanhSachHopDongBiXoa,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListHopDongDelete: (dataSearch) =>
    dispatch(getListHopDongDelete(dataSearch)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DanhSachHopDongBiXoa);
